import { CXoneDigitalContact } from '@nice-devone/digital-sdk';
import { DigitalContactService } from '@nice-devone/digital-sdk/src/lib/digital/service/digital-contact-service';
import { DigitalContactStatusAgent } from 'src/app/shared/enums/digital-contact-status-agent.enum';

export type ChatDirection = 'inbound' | 'outbound';

export class DigitalChatSession {
  private readonly _digitalContactService: DigitalContactService;
  private readonly _customerName: string;
  private readonly _channelName: string;
  private readonly _contactId: string;
  private readonly _caseId: string;
  public lastDirection: ChatDirection | null = null;
  public canIncreaseTimeout = false;

  constructor(
    digitalContactService: DigitalContactService,
    digitalContact: CXoneDigitalContact,
  ) {
    this._digitalContactService = digitalContactService;
    this._contactId = digitalContact?.caseId;

    this._caseId =
      digitalContact?.caseId || digitalContact?.case?.id || this._contactId;
    this._customerName = digitalContact?.customerName || 'cliente';
    this._channelName = digitalContact?.channelType || 'canal';
  }

  public get contactId() {
    return this._contactId;
  }

  public get customerName(): string {
    return this._customerName;
  }

  public get channelName(): string {
    return this._channelName;
  }

  public get customerChannelName(): string {
    return `${this._customerName} (${this._channelName})`;
  }

  public async closeChannel(): Promise<void> {
    await this._digitalContactService.changeCustomerContactStatus(
      this._caseId,
      DigitalContactStatusAgent.RESOLVED,
    );
    await this._digitalContactService.unassignCustomerContact(this._caseId);
  }
}
